type ErrorMessageLike = {
  error(message: string): void;
};

export function showFallbackHttpError(message: ErrorMessageLike, backendMessage: string | null | undefined, fallbackMessage: string): void {
  if (String(backendMessage || '').trim()) {
    return;
  }
  message.error(fallbackMessage);
}
